export const COMPANY = {
  name: "MediElite Practice Solutions",
  tagline: "Precision That Performs",
  email: "info@medielitesolutions.com",
  phone: "+1 786-891-5066",
};

export const KPIS = [
  { value: "98%", label: "Clean Claim Rate" },
  { value: "30%", label: "Faster Collections" },
  { value: "50+", label: "Years Combined Experience" },
  { value: "50", label: "States Licensing Coverage" },
  { value: "15+", label: "Days Faster AR" },
  { value: "95%+", label: "First-Pass Resolution" },
];

export const RCM_SERVICES = [
  {
    title: "Patient Appointment & Intake",
    body:
      "Streamlined scheduling, registration, and demographic capture that reduces no-shows and ensures clean data from the first touchpoint.",
  },
  {
    title: "Eligibility, Benefits & Prior Authorization",
    body:
      "Real-time eligibility checks and proactive prior authorizations to prevent denials and surprise patient balances before the visit.",
  },
  {
    title: "Billing & Charge Entry",
    body:
      "Timely, error-free charge capture and claim preparation with rigorous scrubbing so clean claims go out the door the first time.",
  },
  {
    title: "Claim Rejections & Clearinghouses",
    body:
      "We manage front-end rejections at the clearinghouse, correcting and resubmitting fast to keep cash flow uninterrupted.",
  },
  {
    title: "Secondary Claim Submission",
    body:
      "Coordinated benefits and timely secondary filings to capture every dollar owed after the primary payer adjudicates.",
  },
  {
    title: "Rejections & Denial Management",
    body:
      "Root-cause analysis of denials with corrective action workflows that reduce repeat issues and recover lost revenue.",
  },
  {
    title: "Medical Appeals",
    body:
      "Well-documented, payer-specific appeals written by experienced specialists to overturn denials and secure payment.",
  },
  {
    title: "AR Follow-Up & Patient Collections",
    body:
      "Aggressive yet patient-friendly AR follow-up, statements, and collections to shrink days-in-AR and grow net collections.",
  },
];

const LOGO = (f) => `/assets/logos/${f}`;

export const EHR_LOGOS = [
  { name: "athenahealth", src: LOGO("athenahealth.png") },
  { name: "eClinicalWorks", src: LOGO("eclinicalworks.png") },
  { name: "NextGen Healthcare", src: LOGO("nextgen.png") },
  { name: "Practice Fusion", src: LOGO("practicefusion.png") },
  { name: "MEDITECH", src: LOGO("meditech.png") },
  { name: "Oracle Health (Cerner)", src: LOGO("oracle-cerner.png") },
  { name: "Epic Systems", src: LOGO("epic.png") },
];

export const PAYOR_LOGOS = [
  { name: "Blue Cross Blue Shield", src: LOGO("bcbs.png") },
  { name: "Aetna", src: LOGO("aetna.png") },
  { name: "Cigna", src: LOGO("cigna.png") },
  { name: "Humana", src: LOGO("humana.png") },
  { name: "Wellcare", src: LOGO("wellcare.png") },
  { name: "Centene", src: LOGO("centene.png") },
  { name: "Medicare", src: LOGO("medicare.png") },
  { name: "Molina Healthcare", src: LOGO("molina.png") },
];

export const ACCOUNTING_LOGOS = [
  { name: "QuickBooks Online", src: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Intuit_QuickBooks_logo.svg/320px-Intuit_QuickBooks_logo.svg.png" },
  { name: "Xero", src: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Xero_software_logo.svg/320px-Xero_software_logo.svg.png" },
];

export const SERVICE_OPTIONS = [
  "Revenue Cycle Management (RCM)",
  "Provider & Facility Credentialing",
  "Provider Licensing (IMLC / 50 States)",
  "Bookkeeping & Accounting",
  "EHR / Practice Management Support",
  "Consultation / Other",
];
